'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var reactTransitionGroup = require('react-transition-group');
var accordion = require('../../../../../enums/accordion.js');
require('../../../../../enums/alert.js');
require('../../../../../enums/avatar.js');
require('../../../../../enums/breakpoints.js');
require('../../../../../enums/button.js');
require('../../../../../enums/code-editor.js');
require('../../../../../enums/colors.js');
require('../../../../../enums/combobox.js');
require('../../../../../enums/date.js');
require('../../../../../enums/drag-and-drop.js');
require('../../../../../enums/dialog.js');
require('../../../../../enums/divider.js');
require('../../../../../enums/dropdown.js');
require('../../../../../enums/fieldset.js');
require('../../../../../enums/font-icon.js');
require('../../../../../enums/fonts.js');
require('../../../../../enums/headings.js');
require('../../../../../enums/input.js');
require('../../../../../enums/keys.js');
require('../../../../../enums/list.js');
require('../../../../../enums/listbox.js');
require('../../../../../enums/loader.js');
require('../../../../../enums/margin.js');
require('../../../../../enums/option.js');
require('../../../../../enums/pill.js');
require('../../../../../enums/placements.js');
require('../../../../../enums/popout.js');
require('../../../../../enums/privacy.js');
require('../../../../../enums/radio-group.js');
require('../../../../../enums/status.js');
require('../../../../../enums/switch.js');
require('../../../../../enums/table.js');
require('../../../../../enums/tooltip.js');
require('../../../../../enums/transitions.js');
require('../../../../../enums/widths.js');
var accordionPanel_module = require('../styles/accordion-panel.module.scss.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Accordion panel content.
 * @param {AccordionPanelProps} props AccordionPanelProps
 */ const AccordionPanel = (props)=>{
    const { accordionButtonId , animation =accordion.AccordionAnimations.FadeInFromTop , children , id , loading , open , panelProps , unmountOnExit  } = props;
    const [hidden, setHidden] = React.useState(true);
    const [initial, setInitial] = React.useState(true);
    return /*#__PURE__*/ React__default.default.createElement(reactTransitionGroup.CSSTransition, {
        classNames: {
            enter: accordionPanel_module[`${animation}Enter`],
            enterActive: accordionPanel_module[`${animation}EnterActive`],
            enterDone: accordionPanel_module[`${animation}EnterDone`],
            exit: accordionPanel_module[`${animation}Exit`],
            exitActive: accordionPanel_module[`${animation}ExitActive`]
        },
        in: open,
        onEnter: ()=>setHidden(false),
        onEntered: ()=>setInitial(false),
        onExited: ()=>setHidden(true),
        timeout: !initial && !loading ? 200 : 0,
        unmountOnExit: unmountOnExit
    }, /*#__PURE__*/ React__default.default.createElement("section", _extends({}, panelProps, {
        "aria-labelledby": accordionButtonId,
        className: classnames__default.default('accordion-panel', accordionPanel_module.accordionPanel, panelProps?.className),
        hidden: hidden,
        id: id
    }), children));
};

exports.AccordionPanel = AccordionPanel;
//# sourceMappingURL=accordion-panel.js.map
